<template>
  <div class="orderInfo" >
    <p class="title">2.订餐信息</p>
    <div class="g-content">
      <ul>
        <li>
          <div class="z-title">业务类型</div>
          <div class="z-content">
              <span class="send-type" :class="{'send-type-checked':sendType == 1 || sendType == 4}"
                    @click="changeSendType(1)">
                外卖
              </span>
            <span class="send-type" :class="{'send-type-checked':sendType == 2}" @click="changeSendType(2)">
                自取
              </span>
          </div>
        </li>
        <li>
          <div class="z-title" v-if="sendType == 1 || sendType == 4">送餐省份</div>
          <div class="z-title" v-else>取餐省份</div>
          <div class="z-content">
            <div class="select-province">
              <cc-select v-model="provinceId" :width="160" labelKey="name" valueKey="provinceId" :options="listProvince"
                         @change="selectProvince(provinceId,listProvince)" :isSearch="true"
                         :class="{errorBorder: !provinceId}">
              </cc-select>
            </div>
          </div>
          <div class="z-title p-l12" v-if="sendType == 1 || sendType == 4">送餐城市</div>
          <div class="z-title p-l12" v-else>取餐城市</div>
          <div class="z-content">
            <div class="select-province">
              <cc-select class="select" v-model="cityId" :width="160" labelKey="name" valueKey="cityId"
                         :options="listCity" @change="selectCity(cityId,listCity)" :isSearch="true"
                         :class="{errorBorder: !cityId}">
              </cc-select>
            </div>
          </div>
          <div class="z-title p-l12">区域</div>
          <div class="z-content">
            <div class="select-province">
              <cc-select class="select" v-model="districtId" :width="160" labelKey="name" valueKey="districtId"
                         :options="listDistrict" @change="selectdistrict(districtId,listDistrict)" :isSearch="true"
                         :class="{errorBorder: !districtId}">
              </cc-select>
            </div>
          </div>
        </li>
        <li v-if="sendType == 1 || sendType == 4">
          <div class="z-title">大厦/小区/学校</div>
          <!-- <span v-if='!isSelect' style='color:red;'>请选择请点击联想地址，否则输入框地址将不会被保存</span> -->
          <div class="z-content" @click.stop='searchClick'>
            <div class="detailsearch">
              <div class="searchBox">
                <!--@blur="hideList"-->
                <input class="text detailadd" id="address" @focus="islistShow=true" @blur="hideList"
                       v-model="consigneeAddress" @keyup="inputAddress()" autocomplete="off" ref="addressElement" >
                <i class="cross"></i>
                <div class="list-containter " :style="detailSearchStyle" ref="detailSearchEle"
                     v-show="islistShow&&(addressList.length ||  lastConsigneeAddress.length || consigneeAddress.length )">
                  <ul>
                    <template
                      v-if="islistShow&&(lastConsigneeAddress&&lastConsigneeAddress.length>0||addressList&&addressList.length>0)&&consigneeAddress.length===0">
                      <li v-if="lastConsigneeAddress&&lastConsigneeAddress.length>0"
                          v-for="(item,index) in lastConsigneeAddress" class="list-item" :key="lastConsigneeAddress.length + '-' + index"
                          @mousedown="checkAddress(item)">
                        <Poptip trigger="hover" placement="right" class="am-block" transfer>
                          <div slot="title">
                            <div class="list-item-text">{{item.name}}</div>
                          </div>
                          <div class="list-item-content">
                            <span class="z-tip-his" v-if="item.isHistory">历史地址</span>
                            <span>{{item.name}}</span>
                          </div>
                        </Poptip>
                      </li>
                      <li class="list-item" v-for="(item,index) in addressList" :key="index"
                          @mousedown="checkAddress(item)">
                        <Poptip trigger="hover" placement="right" class="am-block" transfer>
                          <div slot="title">
                            <div class="list-item-text">{{item.district}}{{item.name}}</div>
                          </div>
                          <div slot="content">
                            <div class="list-item-text"> {{item.address}}</div>
                          </div>
                          <div class="list-item-content">
                            <div class=" am-text-truncate">
                              <span class="z-tip-his" v-if="item.isHistory">历史地址</span>
                              <span class="z-tip-black" v-if="item.isWhite">白名单</span>
                              <span>{{item.name}}</span>
                              <span class="list-item-text am-padding-left-sm">{{item.district}}</span>
                            </div>
                            <div class="am-text-truncate list-item-text" v-if="item.address">
                              {{item.address}}
                            </div>
                          </div>
                        </Poptip>
                      </li>
                    </template>
                    <template v-if="islistShow&&addressList&&addressList.length>0&&consigneeAddress.length>0">
                      <li class="list-item" v-for="(item,index) in addressList" :key="index"
                          @mousedown="checkAddress(item)">
                        <Poptip trigger="hover" placement="right" class="am-block" transfer>
                          <div slot="title">
                            <div class="list-item-text">{{item.district}}{{item.name}}</div>
                          </div>
                          <div slot="content">
                            <div class="list-item-text"> {{item.address}}</div>
                          </div>
                          <div class="list-item-content">
                            <div class=" am-text-truncate">
                              <span class="z-tip-his" v-if="item.isHistory">历史地址</span>
                              <span class="z-tip-black" v-if="item.isWhite">白名单</span>
                              <span>{{item.name}}</span>
                              <span class="list-item-text ">{{item.district}}</span>
                            </div>
                            <div class="am-text-truncate list-item-text" v-if="item.address">
                              {{item.address}}
                            </div>
                          </div>
                        </Poptip>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
            <a class="light am-margin-left-sm" @click="showHistoryAddressList"
               v-if="historyAddressList.length">查看历史地址</a>
          </div>
          <div class="z-title p-l12">详细地址</div>
          <div class="z-content">
            <div class="detailsearch">
              <input class="text detailadd" id="appendAddress" v-model="detailAddress">
              <i class="cross"></i>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import CcSelect from '@/components/Select/index';
  import {mapState} from 'vuex';
  import Poptip from '@/components/Poptip/index';
  import {each,getUrlParameter} from '@/utils/assist'
  import Axios from 'axios'

  
  const cityObj = {}; // 城市ID集合 ｛name @string : obj @object｝
  export default {
    name: 'orderInfo',
    data() {
      return {
        getStoreDisabled: true,
        detailSearchStyle: {height: 'auto'}, // 地图搜索的高度
        listProvince: [{name: '全部', provinceId: 0}]
        , listCity: [{name: '全部', cityId: 0}]
        , listDistrict: [{name: '全部', districtId: 0}]
        , provinceId: 0 // 省份Id
        , cityId: 0 //  城市Id
        , districtId: 0 // 区域Id
        , islistShow: false
        , consigneeAddress: '' //地址
        , detailAddress: ''
        , addressList: [] //所有地址列表
        , coordinates: [0, 0] //经纬度集合
        , longitude: 0 //经度
        , latitude: 0 //维度
        , historyAddress: [] // 历史地址
        , associateList: []
        , isFrist: true //是否第一次进入此页面
        , isEqual: false // 是否
        , pageSize: 20
        , once: 0 // 兼容getUser 先拿到用户信息再请求最后一次下单记录
        , wemapTime:''
        , isTencentMap: this.tencentMapKey?true:false//是否使用腾讯地图
        , isSelect:true
        , oldData:{}
      }
    },
    created() {
      if (this.isAmend) {
        this.once = 1;
        this.setAmendOrderBaseInfo();
      } else {
        this.getStoreDisabled = false;
        this.getOpenProvince()
      }
    },
    mounted() {
     
    },
    activated() {
      let  address = this.$store.state.booking.user.consigneeAddress;
      let  user = this.$store.state.booking.user;
      this.oldData = {
        address,
        longitude:user.longitude,
        latitude:user.latitude
      }
        this.$store.dispatch('booking/user/update', {oldAddressData:this.oldData});
        
      console.log('进入页面',address,user.longitude, user.latitude)
    },
    methods: {
      getAllCity () { // 获取所有城市
        return this.server.get({
          name: 'allCityList'
        }).then((res)=> {
          let data = res.data;
          data.forEach(item=> {
            cityObj[item.name] = item;
          });
        })
      },
      startVal() { // 初始化条件
        if (this.getStoreDisabled)return;
        this.consigneeAddress = '';
        this.coordinates = [0, 0];
        this.addressList = [];
        this.latitude = 0;
        this.longitude = 0;
      },
      getCcUserLastFinishOrder() { //CC获取用户最近完成订单
        let userId = this.userInfo.uid,
          once = this.once,
          sendType = this.sendType,
          storeUser = this.$store.state.booking.user,
          isBrandStoreOne = storeUser.isBrandStoreOne,
          storeId = storeUser.storeId;
        if (!userId) return this.once = 0;
        this.server
          .get({
            name: "getCcUserLastFinishOrder",
            data: {
              userId
              , orderType: sendType
              , brandId: this.brandInfo.brandId
            }
          })
          .then(result => {
            if (result.status === 1) {
              if (result.data) {
                let data = result.data,
                  lastAddress = [{
                    isHistory: true,
                    cityId: data.cityId,
                    name: data.consigneeAddress,
                    longitude: data.longitude,
                    latitude: data.latitude,
                    cityName: data.cityName
                  }];
                storeId = data.storeId;
                // 信息回显
                this.$store.dispatch('booking/user/update', {
                  phone: data.consigneePhone,
                  name: data.consigneeName,
                  lastConsigneeAddress: lastAddress, // 保存最后一次下单地址
                  storeId: data.storeId,// 保存最后一次下单门店id
                  selfTakeaddress: data.consigneeAddress //保存自取获取到的最后下单地址
                });
                if(this.isJYJForXL) {
                  this.$store.dispatch('booking/user/update', {
                  vipPhone: data.vipPhone,
                });
                }
                // 获取门店列表
                this.checkAddress(lastAddress[0]);
              } else {
                this.$store.dispatch('booking/user/update', {
                  lastConsigneeAddress: [],
                  selfTakeaddress: ''
                });
              }
            }
          }).finally(() => {
          // 是否只有一家门店，是否首次， 是否门店存在，是否业务类型存在
          if (isBrandStoreOne && once === 1 && storeId && sendType) {
            // this.$emit('openOrderPage', {storeId})
          }
          this.once++;
        })
      },
      getOpenProvince() { //获取已开通省份
        return this.server
          .get({
            name: "getOpenProvince",
            data: {
              brandIds: [this.brandInfo.brandId]
            }
          })
          .then(result => {
            let listProvince = [{name: '全部', provinceId: 0}];
            if (result.status === 1) {
              let list = result.data.map(function (item) {
                return {provinceId: item.provinceId, name: item.provinceName}
              });
              list.length&&listProvince.push(...list);
              this.listProvince = listProvince;
              return listProvince
            }
          })
      },
      getOpenCity() { //获取开放城市
        return this.server
          .get({
            name: "getOpenCity",
            data: {
              brandIds: [this.brandInfo.brandId],
              provinceId: this.provinceId
            }
          })
          .then(result => {
            if (result.status === 1) {
              let listCity = [{name: '全部', cityId: 0}];
              let list = result.data.map((item) => {
                return {cityId: item.cityId, name: item.cityName}
              });
              list.length&&listCity.push(...list);
              this.listCity = listCity;
              return listCity
            }
          })
      },
      getOpenDistrict() { //获取区域
        this.server
          .get({
            name: "getOpenDistrict",
            data: {
              brandIds: [this.brandInfo.brandId],
              cityId: this.cityId
            }
          })
          .then(result => {
            if (result.status === 1) {
              this.listDistrict = [{name: '全部', districtId: 0}];
              result.data.forEach((item) => {
                this.listDistrict.push({districtId: item.districtId, name: item.districtName})
              })
            }
          })
      },
      selectProvince(id, data) { //选择省份
        if (id > 0) {
          this.provinceId = id;
          if (data.length) {
            data.map(x => {
              if (x.provinceId == id) {
                this.$store.dispatch('booking/user/update', {
                  provinceName: x.name
                })
              }
            })
          }
          !this.getStoreDisabled&&this.getOpenCity();
        } else {
          this.provinceId = 0;
        }
        // 用于地图搜索 清除自取时的地址
        if (!this.getStoreDisabled) {
          this.$store.dispatch('booking/user/update', {cityName: '', selfTakeaddress: ''});
          this.listCity = [{name: '全部', cityId: 0}];
          this.cityId = 0;
          this.listDistrict = [{name: '全部', districtId: 0}];
          this.districtId = 0;
        }
      },
      selectCity(id, data) { //选择城市
        if (id > 0) {
          this.cityId = id;
          if (data.length) {
            data.map(x => {
              if (x.cityId == id) {
                this.$store.dispatch('booking/user/update', {
                  cityName: x.name
                })
              }
            })
          }
          this.getOpenDistrict();
        } else {
        }
        // 清除自取时的地址
        if (!this.getStoreDisabled) this.$store.dispatch('booking/user/update', {selfTakeaddress: ''});

        this.listDistrict = [{name: '全部', districtId: 0}];
        this.districtId = 0;
      },
      selectdistrict(id, data) { //选择区域
        if (id > 0) {
          this.districtId = id;
          if (data.length) {
            data.map(x => {
              if (x.districtId == id) {
                this.$store.dispatch('booking/user/update', {
                  districtName: x.name
                })
              }
            })
          }
        } else {
          this.districtId = 0;
        }
      },
      actionLoading(boole) {
        this.$store.dispatch('booking/user/update', {
          storeListLoading: !!boole
        })
      },
      getFindStoresByConds(cityId) { //根据复合条件获取门店列表
        if (this.getStoreDisabled)return; // 获取门店禁用
        this.actionLoading(true);
        this.server
          .get({
            name: "getFindStoresByConds",
            data: {
              // content:{
              address: this.sendType == 2 ? '' : this.consigneeAddress
              , brandName: this.brandInfo.brandName
              , storeName: ''
              , orderType: this.sendType
              , provinceId: this.provinceId
              , cityId: this.cityId||cityId
              , districtId: this.districtId
              , brandIds: [this.brandInfo.brandId]
              , storeIds: []
              , coordinates: this.sendType == 2 ? [0, 0] : this.coordinates
              , pageSize: this.pageSize
              , pageNow: this.pageNow
              // }
              // ,platformKey: this.brandInfo.platformKey
            }
          })
          .then(result => {
            if (result.status === 1) {
              let o = {};
              if (result.data.rows.length > 0) {
                let data = result.data;
                o = {
                  storeList: data.rows,
                  pageNow: data.page,
                  pages: data.pages,
                  total: data.total
                };
                // 判断分页
                o.isNext = !!(result.data.total > (result.data.page * result.data.pageSize));
                o.isPre = result.data.page !== 1;
              } else {
                // 重置
                o = {
                  storeList: [],
                  pageNow: 1,
                  pages: 0,
                  total: 0,
                  isPre: false,
                  isNext: false
                };
                this.getNearestStoreWithoutRange()
              }
              this.$store.dispatch('booking/user/update', o)
            }
          }).finally(() => {
          this.actionLoading()
        })
      },
      getNearestStoreWithoutRange() { //获取最近门店(无视配送范围)
        if (this.sendType == 2 || this.consigneeAddress == '') {
          return
        } //自取的时候不需要获取
        this.actionLoading(true);
        this.server
          .get({
            name: "getNearestStoreWithoutRange",
            data: {
              // content:{
              orderType: this.sendType
              , brandIds: [this.brandInfo.brandId]
              , coordinates: this.coordinates
              // }
              // ,platformKey: this.brandInfo.platformKey
            }
          }).then(result => {
          if (result.status === 1) {
            if (result.data) {
              result.data.isRange = false
            }
            this.$store.dispatch('booking/user/update', {storeList: [result.data]})
          }
        }).finally(() => {
          this.actionLoading()
        })
      },
      changeSendType(sendType) {
        // 存放在store
        if (this.isAmend) {
          return this.$Modal.error({
            title: '提示',
            content: '修改订单中,不可以切换业务'
          });
        }
        this.$store.dispatch('booking/user/update', {sendType});
        if (sendType === 1 || sendType === 4) {
          // 获取最后完成订单信息
          this.getCcUserLastFinishOrder();
        } else if (sendType === 2) {
          // 初始化数据
          this.getCcUserLastFinishOrder();
        }
        // 重新获取门店列表
        this.getFindStoresByConds();
      },
      searchClick(){
        console.log('查询内点击')
      },
      searchOther(){
        console.log('查询外点击',this.cart,this.$store.state.booking.user.address)
       
        if(this.isSelect){
          return;
        }

        // 购物车选择过餐品的如果修改地址，则出现提示弹窗
        // if(this.cart&&this.cart.menuId){
          this.$Modal.confirm({
            title: '提示',
            content: '请选择请点击联想地址，否则输入框地址将不会被保存',
            okText: '继续',
            cancelText: '放弃修改',
            onOk: () => {
              
            },
            onCancel: () => {
              //  this.oldData = {
              //   address,
              //   longitude:user.longitude,
              //   latitude:user.latitude
              // }
              this.longitude = this.oldData.longitude
              this.latitude = this.oldData.latitude
              this.consigneeAddress = this.oldData.address
              this.isSelect = true;
              this.$store.dispatch('booking/user/update', {latitude:this.latitude,longitude:this.longitude});



            }
          });
        // }
        
        
      },
      inputAddress() { // 搜索顺序=历史地址->地图地址->白名单地址
        // 腾讯地图
        if(this.tencentMapKey){
          if(this.wemapTime){
            clearTimeout(this.wemapTime)
          }
          this.wemapTime = setTimeout(()=>{
            this.wemapSearch();
          },400)
          return false;
        }
      

        let that = this, white = [], historyList = [], tips = [];
        if ((that.sendType == 1 || that.sendType == 4) && that.consigneeAddress == '') {
          // 初始化数据
          this.startVal();
          // 重新获取门店列表
          this.getFindStoresByConds();

          // 获取用户历史地址 鼠标移入显示所有用户地址库的地址
          if (this.historyAddressList.length > 0) {
            this.historyAddressList.forEach(x => {
              x.isHistory = true;
              x.name = x.receiverAddress;
              that.addressList.push(x)
            })
          }
          return;
        }
        // 获取用户历史地址
        if (this.historyAddressList.length > 0) {
          this.historyAddressList.forEach(x => {
            if (x.receiverAddress.includes(that.consigneeAddress)) {
              x.isHistory = true;
              x.name = x.receiverAddress;
              historyList.push(x)
            }
          })
        }
        
        
        //查询地图地址
        this.autocomplete = new AMap.Autocomplete({
          city: this.cityName
          , citylimit: true
        })
        this.autocomplete.search(that.consigneeAddress, function (status, result) {
          // console.log(status, result,555)
          // 第三方地图有返回
          if (status == 'complete') {
            let tipsArr = []
            // 地图地址处理 需加上district+name
            if (result.tips && result.tips.length > 0) {
              result.tips.map(item => {
                let {district = '', address, name} = item;
                if (item.location && name) { //过滤坐标为空的地址
                  name = name.replace(district, '');
                  item.address = '' + address;
                  tipsArr.push({...item, name, label: item.name});
                }
              })
            }
            that.addressList = historyList.concat(tipsArr);

          } else if (status == 'no_data') {
            // 白名单地址
            that.server.get({
              name: "getListWhiteListAddress", data: {
                // content:{
                brandIds: [that.brandInfo.brandId]
                , storeIds: []
                , storeId: 0
                , address: that.consigneeAddress
                , status: 1
                , pageNow: 1
                , pageSize: 10
                // }
              }
            }).then(result1 => {
              if (result1.status === 1) {
                if (result1.data.rows.length > 0) {
                  result1.data.rows.map(x => {
                    x.isWhite = true;
                    x.name = x.address;
                  });
                  that.addressList = historyList.concat(result1.data.rows)
                }
              }
            })
          }
        })
      },
      wemapSearch(){
         document.body.addEventListener('click',this.searchOther);
        let that = this, white = [], historyList = [], tips = [];
        if ((that.sendType == 1 || that.sendType == 4) && that.consigneeAddress == '') {
          // 初始化数据
          this.startVal();
          // 重新获取门店列表
          this.getFindStoresByConds();

          // 获取用户历史地址 鼠标移入显示所有用户地址库的地址
          if (this.historyAddressList.length > 0) {
            this.historyAddressList.forEach(x => {
              x.isHistory = true;
              x.name = x.receiverAddress;
              that.addressList.push(x)

            })
          }
          that.addressList.length&&(that.isSelect = false);
          console.log('联想列表')
          return;
        }
        // 获取用户历史地址
        if (this.historyAddressList.length > 0) {
          this.historyAddressList.forEach(x => {
            if (x.receiverAddress.includes(that.consigneeAddress)) {
              x.isHistory = true;
              x.name = x.receiverAddress;
              historyList.push(x)
            }
          })
        }
        let data = {
          keyword:this.consigneeAddress,
          key: this.tencentMapKey, //key为自己向腾讯地图申请的密钥
          region:this.cityName,
          output:'jsonp',
          region_fix:1
        };

        var url = "https://apis.map.qq.com/ws/place/v1/suggestion/";
        $.ajax({
          type: "get",
          dataType: 'jsonp',
          data: data,
          url: url,
          async:false,
          jsonp:'callback',
          success: function (result) {

                let tipsArr = []
              // 地图地址处理 需加上district+name
              if (result.data && result.data.length > 0) {
               
                result.data.map(item => {
                  let {district = '', address, title} = item;
                  if (item.location && title) { //过滤坐标为空的地址
                    let name = title.replace(district, '');
                    item.address = '' + address;
                    tipsArr.push({...item, name, label: item.name});
                  }
                })
              }
              that.addressList = historyList.concat(tipsArr);
              if(that.addressList.length){
                that.isSelect = false;
                console.log('联想列表')
              }
            
          },
          error: function (err) {
              console.log(err,'smileer r');
          }
        });
      },
      showHistoryAddressList() {
        let list = this.historyAddressList,
          element = this.$refs.addressElement;
        // 获取用户历史地址 鼠标移入显示所有用户地址库的地址
        if (list.length > 0) {
          list.forEach(x => {
            x.isHistory = true;
            x.name = x.receiverAddress;
          });
          this.addressList.splice(0, this.addressList.length, ...list);
          element.focus();
        }
      },
      
      // 修改地址后，如果购物车已经选择过餐品，判断当前地址是否在配送范围内
      isCheckStore(cityId){
        if(this.$store.state.booking.cart
            &&this.$store.state.booking.cart.menuId
            &&this.$store.state.booking.store
            &&this.$store.state.booking.store.data
            &&this.$store.state.booking.store.data.storeId)
        {
          let storeId = this.$store.state.booking.store.data.storeId;
            return this.server.get({
            name: "getFindStoresByConds", data: {
              // content:{
              address: this.sendType == 2 ? '' : this.consigneeAddress
              , brandName: this.brandInfo.brandName
              , storeName: ''
              , orderType: this.sendType
              , provinceId:this.provinceId
              , cityId:this.cityId||cityId
              , districtId:this.districtId
              , brandIds: [this.brandInfo.brandId]
              , storeIds: [storeId]
              , coordinates: this.coordinates
              , pageSize: this.pageSize
              , pageNow: this.pageNow
            }
          }).then(result => {
            if(result.status==1&&result.data.rows.length){
              return true
            }else {
              return false
            }
          })
        }else{
          return true
        }
        
      },
      async checkAddress(item) { // 选择地址 @isHistory boolean 历史地址 @isWhite boolean 白名单  @cityId 城市地址ID number
        let districtDetailsAddress = Array.isArray(item.city) ? item.district : item.cityName,
          districtId = this.districtId,
          provinceId = this.provinceId,
          isHistory = item.isHistory,
          isWhite = item.isWhite,
          longitude,
          latitude,
          cityId = this.cityId;
        this.islistShow = false;
        this.consigneeAddress = item.name;
        if (isHistory || isWhite) { // 历史地址
          longitude = item.longitude;
          latitude = item.latitude;
          cityId = item.cityId || cityId;
          console.log(item)
        } else {
          longitude = item.location.lng;
          latitude = item.location.lat;
        }
        if (!cityId&&!isHistory) { // 没有城市ID也不是历史地址 用高德返回的城市ID匹配城市code
          let district = item.district, cityName = item.city||'';
          each(district.match(/.+?(省|市|自治区|自治州|县|区)/g), function (value) {
            if (value.indexOf('市')>-1) cityName = value;
          });
          if (cityName.length) {
            if (Object.keys(cityObj).length === 0) {
              await this.getAllCity();
            }
            if (cityObj[cityName]) {
              let obj = cityObj[cityName];
              cityId = obj.cityId;
              provinceId = obj.provinceId
              // this.cityId = cityId;
              // this.provinceId = obj.provinceId
            }
          }
        }
        this.coordinates = [longitude, latitude];
        console.log(this.coordinates,'this.coordinates')
        // 保存用户输入地址坐标
        this.$store.dispatch('booking/user/update', {longitude, latitude, districtDetailsAddress});
        console.log('选择对应地址')
        this.isSelect = true;
        // this.$store.dispatch("userPosition",{longitude:this.longitude,latitude:this.latitude});
        this.actionLoading(true);
        this.longitude = longitude;
        this.latitude = latitude;
        let check = await this.isCheckStore(cityId);
        // 地址不在原门店配送范围内
        let isChange = false
        let urlObj = getUrlParameter();
        if (typeof urlObj === 'object' && urlObj.hasOwnProperty('platformKey') && urlObj.hasOwnProperty('orderId')) { // OCRM链接跳转入口 修改订单初始化
          isChange = true
        }
        if(!check&&!isChange&&this.sendType==1){
          if(Object.keys(this.$store.state.booking.cart.products).length){
            this.$Modal.confirm({
              title: '提示',
              content: '新地址不在原门店配送范围，切换地址将清空原门店购物车餐品，是否继续？',
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                //清空购物车刷新列表
                this.$store.dispatch('booking/cart/clear');
                this.$store.dispatch('booking/user/update', {storeId:0});
                this.getFindStoresByConds(cityId);

              },
              onCancel: () => {
                //地址栏回选之前地址
                this.longitude = this.oldData.longitude
                this.latitude = this.oldData.latitude
                this.coordinates = [this.longitude,this.latitude]
                this.consigneeAddress = this.oldData.address;
                this.$store.dispatch('booking/user/update', {latitude:this.latitude,longitude:this.longitude});
                this.getFindStoresByConds(cityId);
              }
            });
          }else{
            this.$store.dispatch('booking/cart/clear');
            this.$store.dispatch('booking/user/update', {storeId:0});
            this.getFindStoresByConds(cityId);
          }

          return false
        }
        // 逻辑 若为外卖或外卖预约 门店列表的搜索框有关。切换类型，原数据必须保持不变。
        this.server.get({
          name: "getFindStoresByConds", data: {
            // content:{
            address: this.sendType == 2 ? '' : this.consigneeAddress
            , brandName: this.brandInfo.brandName
            , storeName: ''
            , orderType: this.sendType
            , provinceId
            , cityId
            , districtId
            , brandIds: [this.brandInfo.brandId]
            , storeIds: []
            , coordinates: this.coordinates
            , pageSize: this.pageSize
            , pageNow: this.pageNow
            // }
            // ,platformKey: this.brandInfo.platformKey
          }
        }).then(result => {
          if (result.status === 1) {
            let o = {};
            if (result.data.rows.length > 0) {
              o = {
                storeList: result.data.rows,
                pageNow: result.data.page,
                pages: result.data.pages,
                total: result.data.total
              };
              // 判断分页
              if (result.data.total > (result.data.page * result.data.pageSize)) {
                o.isNext = true;
              } else {
                o.isNext = false;
              }
              o.isPre = !(result.data.page == 1);
              // this.$store.dispatch("storeList",result.data.rows);
              this.$store.dispatch('booking/user/update', o);
            } else {
              // 重置
              this.$store.dispatch('booking/user/update', {
                storeList: [],
                pageNow: 1,
                pages: 0,
                total: 0,
                isPre: false,
                isNext: false
              });
              this.getNearestStoreWithoutRange()
            }
          }
        }).finally(() => {
          this.actionLoading()
        })
      },
      hideList() {
        var _this = this;
        setTimeout(function () {
          _this.islistShow = false;
        }, 16)
      },
      isShowList() {
        return true
      },
      updateAddress() {
        let address = this.consigneeAddress + this.detailAddress;
        this.$store.dispatch('booking/user/update', {
          address
        })
      },
      async setAmendOrderBaseInfo () { //设置修改订单基础信息
        this.getStoreDisabled = true;
        if (this.listProvince)
        await this.getOpenProvince();
        let storeUser = this.$store.state.booking,
            userData = storeUser.user,
            orderData = userData.orderAmend.orderData;
        this.provinceId = orderData.provinceId || 0;
        await this.getOpenCity();
        this.cityId = orderData.cityId || 0;
        this.$nextTick(() => {
          this.consigneeAddress = userData.address;
          this.latitude = userData.latitude;
          this.longitude = userData.longitude;
          this.getStoreDisabled = false;
        })
      }
    }
    , components: {
      CcSelect,
      Poptip
    }
    , computed: {
      ...mapState({
        sendType: state => state.booking.user.sendType,
        brandInfo: state => state.booking.user.brandInfo,
        userInfo: state => state.booking.user.data,
        provinceName: state => state.booking.user.provinceName,
        districtName: state => state.booking.user.districtName,
        historyAddressList: state => state.booking.user.historyAddressList || [],
        lastConsigneeAddress: state => state.booking.user.lastConsigneeAddress || [], // 自取单信息
        // 门店分页数据
        pageNow: state => state.booking.user.pageNow,
        total: state => state.booking.user.total,
        pages: state => state.booking.user.pages,
        isPre: state => state.booking.user.isPre,
        isNext: state => state.booking.user.isNext,
        cityName: state => state.booking.user.cityName,
        isAmend: state => state.booking.user.orderAmend.isAmend,
        tencentMapKey:state =>state.booking.user.tencentMapKey,
        cart: state => state.booking.cart

      }),
      isJYJForXL() {
        return (!window.standardDB && (this.brandInfo.platformKey === 'cfffb941289a08f9' || this.brandInfo.platformKey === '0198e4d9557e9a23')) || (window.standardDB && ((this.brandInfo.platformKey === 'b93a3d359a795d9c' || this.brandInfo.platformKey === 'b93a3d359a795d9c')) )
      },
    }
    , watch: {
      provinceId(val, oldVal) {
        if (val !== oldVal) {
          this.$store.dispatch('booking/user/update', {
            provinceId: this.provinceId
          });
          // 初始化数据
          this.startVal();
          // 重新获取门店列表
          this.getFindStoresByConds();
        }
      },
      userInfo() {
        if (this.once === 0) {
          this.once = 1;
          this.getCcUserLastFinishOrder();
        }
      },
      cityId(val, oldVal) {
        if (val !== oldVal) {
          this.$store.dispatch('booking/user/update', {
            cityId: this.cityId
          });
          // 初始化数据
          this.startVal();
          // 重新获取门店列表
          this.getFindStoresByConds();
        }
      },
      districtId(val, oldVal) {
        if (val !== oldVal) {
          this.$store.dispatch('booking/user/update', {
            districtId: this.districtId
          });
          // 初始化数据
          this.startVal();
          // 重新获取门店列表
          this.getFindStoresByConds();
        }
      },
      consigneeAddress() {
        this.$store.dispatch('booking/user/update', {
          consigneeAddress: this.consigneeAddress
        });
        this.updateAddress()
      },
      detailAddress() {
        this.$store.dispatch('booking/user/update', {
          detailAddress: this.detailAddress
        });
        this.updateAddress()
      },
      addressList(list) {
        // 地址监听
        this.$nextTick(() => {
          let ele = this.$refs.detailSearchEle, height = 0;
          if (list && list.length > 6) {
            let childs = ele.querySelectorAll('li.list-item');
            childs.forEach((child, index) => {
              if (index < 6) {
                height += child.offsetHeight;
              }
            });
            height += 'px'
          } else {
            height = 'auto'
          }
          this.detailSearchStyle = {height}
        })
      },
      isAmend (val) {
        if (val) {
          this.setAmendOrderBaseInfo();
        }
      }

    }
  }
</script>

<style lang="scss">
  /* 订餐信息 */
  .send-type {
    margin-right: 10px;
    box-sizing: border-box;
    display: inline-block;
    width: 56px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #758497;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }

  .send-type-checked {
    background-color: #ff823e;
    color: #fff;
  }

  .z-content .select-province {
    float: left;
    margin-top: 6px;
    position: relative;
    width: 160px;
    height: 30px;
    line-height: 30px;
    background-color: #fff;
  }

  .detailsearch {
    display: inline-block;
    position: relative;
    .detailadd.text {
      width: 300px;
      // padding-right: 24px;
    }
    .searchBox {
      position: relative;
      height: 30px;
      line-height: 30px;
      .list-containter {
        position: absolute;
        left: 0;
        top: 30px;
        width: 100%;
        z-index: 20;
        background: #fff;
        color: #3e3f43;
        border: 1px solid #59738c;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        .list-item {
          width: 100%;
          color: #3e3f43;
          cursor: pointer;
          &:nth-child(n+2) {
            border-top: 1px solid rgb(242, 242, 242);
          }
          .list-item-text {
            color: #A1A1A1;
          }
          .list-item-content {
            padding: 5px 8px;
            line-height: 1.5em;
          }
          .z-tip-his {
            width: 54px;
            padding: 0 6px;
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            background-color: #3fa2ff;
            color: #fff;
            border-radius: 2px;
          }
          .z-tip-black {
            width: 54px;
            padding: 0 6px;
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            background-color: #ebedef;
            color: #333;
            border-radius: 2px;
          }
        }
        .list-item:hover {
          background-color: #d1dfe3;
        }
      }
    }
  }
</style>

<style>

</style>



// WEBPACK FOOTER //
// components/Pages/customer/OrderInfo.vue